<template>
  <div
    class="modal modal-exito fade"
    id="modal-exito"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-exito__dialog modal-dialog-centered">
      <div class="modal-content modal-exito__content-exito">
        <div class="modal-header modal-exito__header pb-0">
          <img
            src="../../../assets/img/intranet/encuesta/cara-feliz.svg"
            class="modal-exito__icono-exito"
            alt="Ícono de valor"
          />
        </div>
        <div class="modal-body modal-exito__body py-0">
          <div class="container modal-exito__container">
            <div class="row modal-exito__row justify-content-center">
              <div
                class="col-lg-7 col-md-9 col-10 modal-exito__col text-center"
              >
                <p class="modal-exito__parrafo">
                  Tu encuesta ha sido ingresada correctamente
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            modal-footer
            modal-exito__footer
            pb-4
            position-relative
            text-center
          "
        >
          <button
            class="modal-exito__btn-finalizar px-4 py-1"
            data-bs-dismiss="modal"
            @click="reload()"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EncuestaModalExito",
  methods: {
    reload() {
      this.$router.push({ name: "Encuesta" })
    },
  },
};
</script>